export const en = {
    'amnesty-price': 'Click price',
    bid: 'Bid',
    'bid-forecast': 'Traffic forecast',
    'low-shows-warning': 'With the current bid, few impressions are expected on search.'
};
